import {
  PaymentMethod,
  CreatePaymentMethodResponse,
  BankAccount,
  CardAccount,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const CREATE_PAYMENT_METHOD_URI = '/api/payments/payment-method';

interface CreatePaymentMethodOptions {
  buyerId: string;
  paymentMethodType: string;
  apiFetch: APIFetch;
  cardAccount?: CardAccount;
  bankAccount?: BankAccount;
}

export async function createPaymentMethod({
  buyerId,
  paymentMethodType,
  apiFetch,
  cardAccount,
  bankAccount,
}: CreatePaymentMethodOptions): Promise<
  HandlerResponse<CreatePaymentMethodResponse>
> {
  if (paymentMethodType === 'BANK_ACCOUNT' && !bankAccount) {
    throw new Error('Cannot create payment method without bank account.');
  }

  if (paymentMethodType === 'CARD_ACCOUNT' && !cardAccount) {
    throw new Error('Cannot create payment method without card account.');
  }

  const res: APIResponse<CreatePaymentMethodResponse> = await apiFetch<
    CreatePaymentMethodResponse,
    PaymentMethod
  >(
    CREATE_PAYMENT_METHOD_URI,
    {
      method: 'POST',
      body: {
        id: '',
        scopeID: buyerId,
        scopeType: 'BUYER',
        paymentMethodType,
        cardAccount,
        bankAccount,
      },
    },
    CreatePaymentMethodResponse
  );

  return handleResponse(res);
}
